<template>
  <div>
    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>

    <div v-if="this.loadingFormSubmit == false" class="form-container">
      <el-card class="form-card">
        <h3>Edit Property: {{ property.propertyname }}</h3>
        <div id="updatePropertyForm">
          <el-form :model="form" ref="form" :rules="rules">
            <el-form-item label="Current Image">
              <div>
                <img class="imagecontainer" :src="this.form.imageurl" label="current image" />
              </div>
            </el-form-item>
            <el-form-item label="Image">
              <PictureUpload
              :propertyid="this.propertyid"
                v-on:picture-id="handlePictureid($event)"
                v-on:displaypicturelocally="handlePictureLocally($event)"
                v-on:removePictureId="RemovePictureIdLocally($event)"
              />
            </el-form-item>
            <el-form-item label="Property Name" prop="propertyname">
              <el-input
                class="tst-property-name"
                v-model="form.propertyname"
                :value="property.propertyid"
                :rules="inputRules"
                placeholder="ex: Brooklyn Heights Apartment Complex"
                required
              ></el-input>
            </el-form-item>

            <el-form-item label="Search for address:">
              <br />
              <vue-google-autocomplete
                ref="googleAddress"
                id="map"
                class="google-map-field"
                placeholder="Please type your address"
                v-on:placechanged="setAddressData"
              ></vue-google-autocomplete>
            </el-form-item>

            <el-form-item label="Street Address">
              <el-input
                class="tst-property-address"
                v-model="form.address"
                :rules="inputRules"
                placeholder="ex: 21 Green Street"
                required
              ></el-input>
            </el-form-item>

            <el-form-item label="City">
              <el-input
                class="tst-property-city"
                v-model="form.city"
                :rules="inputRules"
                placeholder="ex: New York City"
                required
              ></el-input>
            </el-form-item>

            <el-form-item label="State">
              <el-input class="tst-property-state"
                v-model="form.state" :rules="inputRules" placeholder="ex: New York" required></el-input>
            </el-form-item>

            <el-form-item label="Zip Code">
              <el-input class="tst-property-zip"
                v-model="form.zip" :rules="inputRules" placeholder="ex: 11234" required></el-input>
            </el-form-item>

            <el-form-item label="Country">
              <el-input class="tst-property-country"
                v-model="form.country" :rules="inputRules" placeholder="ex: USA" required></el-input>
            </el-form-item>
          </el-form>
        </div>

        <el-button class="tst-edit-property-button"
                text @click="updateProperty(property.propertyid, form)">Update Property</el-button>
        <el-button class="tst-cancel-edit-button"
                text @click="cancelUpdate()">Cancel</el-button>
      </el-card>
    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
import PictureUpload from "@/components/utilities/PictureUploadSingle.vue";
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  components: {
    PictureUpload,
    VueGoogleAutocomplete
  },
  props: {
    property: Object
  },
  data() {
    return {
      currentorganizationtypeslist: this.property.organizationtypes,
      neworganizationtypeslist: [],
      editedorganizationtypelist: [],
      deletedorganizationtypelist: [],
      googleAddress: "",
      propertyid: this.property.propertyid,
      form: {
        propertyname: this.property.propertyname,
        address: this.property.address,
        city: this.property.city,
        state: this.property.state,
        zip: this.property.zip,
        country: this.property.country,
        organizationtypesupdate: [],
        imageurl: [this.property.imageurl[0]],
        propertyid: this.property.propertyid,
        ownerfirstname: this.property.ownerfirstname,
        ownerlastname: this.property.ownerlastname,
        pictureid: [],
        canedit: this.property.canedit,
        candelete: this.property.candelete,
        canleaveproperty: this.property.canleaveproperty
      },
      inputRules: [v => (v && v.length != 0) || "This field is required"],
       rules: {
          propertyname: [
            { required: true, message: 'Please input Property name', trigger: 'blur' },
          ],
       },
       invalid: Boolean,
       loadingFormSubmit: false
    };
  },
  computed: {},
  methods: {
    handlePictureid($event) {
      //for (const object of $event) {
      this.form.pictureid.push($event.pictureid);

      //}

      // this.$set(this.form.imageurl, object.imageurl, 0);
    },
    handlePictureLocally($event) {
      this.form.imageurl.unshift($event);
    },
    RemovePictureIdLocally(img) {
      this.$delete(this.form.pictureid, this.form.pictureid.indexOf(img));
      this.form.imageurl.shift();
    },
    updateProperty(propertyid, propertydata) {
        this.$refs["form"].validate((valid) => {
          if (valid) {
          } else {
            this.invalid = true;
            return false;
          }
        });
        if(this.invalid == true){
              this.invalid = false;
          return;
        }
      // this.form.organizationtypes = Object.values(
      //   this.form.organizationtypes
      // );

      this.loadingFormSubmit = true;

      this.form.organizationtypesupdate = this.form.organizationtypesupdate.concat(
        this.editedorganizationtypelist,
        this.deletedorganizationtypelist
      );
      this.addNewOrganizationType();
      EventService.updateProperty(propertyid, propertydata)
        .then(response => {

        this.$store.dispatch("addNotification", {
            type: "success",
            Message: "Property Updated"
          })

          let updatepropertypackage = [propertydata, this.property];
          this.$emit("updated-property", updatepropertypackage);
        })
        .catch(error => {
            console.log(error);
            this.cancelUpdate();
        });
      this.editedorganizationtypelist = [];
    },
    addNewOrganizationType() {
      if (this.neworganizationtypeslist.length > 0) {
        for (const orgtype of this.neworganizationtypeslist) {
          let test = {
            flag: "p",
            organizationtypename: this.neworganizationtypeslist[
              this.neworganizationtypeslist.indexOf(orgtype)
            ]
          };

          this.form.organizationtypesupdate.push(test);
        }
      }
    },
    updateOrganizationName(updatedOrganizationObject) {
      this.form.organizationtypesupdate.push(updatedOrganizationObject);
    },
    deleteOrganizationType(organization) {
      let test = {
        organizationtypeid: organization.organizationtypeid,
        organizationtypename: organization.organizationtypename,
        flag: "d"
      };

      this.deletedorganizationtypelist.push(test);
      test = null;

      this.$delete(
        this.currentorganizationtypeslist,
        this.currentorganizationtypeslist.indexOf(organization)
      );
    },
    cancelUpdate() {
      if (this.deletedorganizationtypelist.length > 0) {
        for (const orgtype of this.deletedorganizationtypelist) {
          this.currentorganizationtypeslist.push(orgtype);
        }
        this.deletedorganizationtypelist = [];
      }
      this.$emit("close-edit-property");
    },
    setAddressData: function(addressData, placeResultData, id) {
      const addressComponents = placeResultData.address_components;
      const streetNumberComponent = addressComponents.find(({ types }) =>
        types.includes("street_number")
      );
      const streetNameComponent = addressComponents.find(({ types }) =>
        types.includes("route")
      );
      const addressComponent = streetNumberComponent
        ? streetNumberComponent.long_name + ""
        : "" + streetNameComponent
        ? streetNameComponent.long_name
        : "";
      const zipComponent = addressComponents.find(({ types }) =>
        types.includes("postal_code")
      );
      const cityComponent = addressComponents.find(
        ({ types }) =>
          types.includes("administrative_area_level_3") ||
          types.includes("sublocality_level_1")
      );
      const stateComponent = addressComponents.find(({ types }) =>
        types.includes("administrative_area_level_1")
      );
      const countryComponent = addressComponents.find(({ types }) =>
        types.includes("country")
      );

      this.form.address = addressComponent;
      this.form.zip = zipComponent ? zipComponent.long_name : "";
      this.form.city = cityComponent ? cityComponent.long_name : "";
      this.form.state = stateComponent ? stateComponent.long_name : "";
      this.form.country = countryComponent ? countryComponent.long_name : "";
    }
  }
};
</script>

<style scoped>
.google-map-field {
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
.imagecontainer {
  height: 200px;
  max-height: 200px;
}
</style>
